// Shelves are spaced 10" apart by default; unlisted shelf names fall back to that in computeShelfOffsets.
export const SHELF_SPACING: Record<string, number> = {
  'medball shelf'    : 4,
  'dumbbell shelf'   : 2,
  'kettlebell shelf' : 2,
  'liner'            : 2,
  'bumper'           : 4,
  'panel'            : 0,
}

// Shared by Cave and Hybrid, both of which stack a shelf's own extra thickness (in inches) onto the ones above it. Hybrid passes its own table so the two products can be spaced independently.
export function computeShelfOffsets(shelves: (string | undefined)[], spacing: Record<string, number> = SHELF_SPACING): number[] {
  const offsets: number[] = []
  let accumulated = 0

  for (const shelf of shelves) {
    offsets.push(accumulated)
    accumulated += shelf ? (spacing[shelf] ?? 10) : 0
  }

  return offsets
}
